import { render, staticRenderFns } from "./RequisitionSampleRangeSelection.vue?vue&type=template&id=12084462&scoped=true&"
import script from "./RequisitionSampleRangeSelection.vue?vue&type=script&lang=js&"
export * from "./RequisitionSampleRangeSelection.vue?vue&type=script&lang=js&"
import style0 from "./RequisitionSampleRangeSelection.vue?vue&type=style&index=0&id=12084462&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12084462",
  null
  
)

export default component.exports